import { $, merge } from "glamor";
import memoizeOne from "memoize-one";
import { theme } from "styles/theme";

export const customOptionStyles = memoizeOne(() =>
    merge(
        {
            width: "100%",
        },
        $(" .attribute", {
            display: "flex",
            justifyContent: "space-between",
            cursor: "pointer",
        }),
        $(" .attributeName", {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: "pointer",
        }),
        $(" .assortmentName", {
            maxWidth: "80%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontWeight: "400",
            fontSize: "10px",
        }),
        $(" .attributeUserDefined", {
            backgroundColor: theme.palette.blue,
            color: theme.palette.white,
            borderRadius: "5px",
            height: "20px",
            fontWeight: "700",
            marginLeft: "10px",
        }),
        $(" .attributeUserDefined > span", {
            padding: "5px !important",
        })
    )
);
